import { render } from "./Fiction.vue?vue&type=template&id=0ca3b5a4&scoped=true"
import script from "./Fiction.vue?vue&type=script&lang=js"
export * from "./Fiction.vue?vue&type=script&lang=js"

import "./pageStyle.css?vue&type=style&index=0&id=0ca3b5a4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca3b5a4"]])

export default __exports__